
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/real-estate-agents-anti-money-laundering",
      function () {
        return require("private-next-pages/real-estate-agents-anti-money-laundering.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/real-estate-agents-anti-money-laundering"])
      });
    }
  